import { EditButton, FunctionField, Show, SimpleShowLayout, TopToolbar } from "react-admin"
import AdminEntity from "../admins"

import React from "react"
import { getRole } from "../../utils/localStorage"

const Admin = ({ record }) => {
  return (
    <SimpleShowLayout
      sx={{
        width: "fit-content",
        padding: "2em 10em 5em 2em",
        position: "relative",
      }}
    >
      <FunctionField label="E-mail" render={() => record.email} />
      <FunctionField label="Jméno" render={() => `${record.firstName} ${record.surname}`} />
      {record.phoneNumber && (
        <FunctionField
          label="Tel. číslo"
          render={() => `${record.phoneNumberPrefix} ${record.phoneNumber}`}
        />
      )}
      <img
        src="/icons/admin.svg"
        alt="Admin Icon"
        style={{
          position: "absolute",
          width: "10em",
          height: "10em",
          right: "1em",
          bottom: "1em",
          zIndex: 1,
          opacity: 0.27,
        }}
      />
    </SimpleShowLayout>
  )
}

const ShowActions = ({ permissions, role }) =>
  permissions[role].includes("u") ? (
    <TopToolbar>
      <EditButton />
    </TopToolbar>
  ) : null

const ShowEntity = ({ record }) => {
  const { permissions, label } = AdminEntity
  const role = getRole()

  return (
    <Show
      entity={AdminEntity}
      actions={<ShowActions permissions={permissions} role={role} />}
      title={label}
      sx={{
        width: "fit-content",
        margin: "2em",
        position: "relative",
      }}
    >
      <Admin record={record} />
    </Show>
  )
}

export default ShowEntity
